<template>
	<span>
		<span :uk-toggle="'target: #cards-generator-modal'">
			<i class="fad fa-camera"></i> <span>{{ buttonText }}</span>
		</span>

		<div :id="'cards-generator-modal'" uk-modal>
			<div class="uk-modal-dialog uk-modal-body">
					
				<h3>Card genereren</h3>
																			
				<form 
					method="post" 
					accept-charset="UTF-8" 
					@submit.prevent="submitForm"
				>						
					<input type="hidden" v-model="formData.imageUrl" ref="imageUrl" />
					<input type="hidden" v-model="formData.imageTeaserUrl" ref="imageTeaserUrl" />
				
					<!-- template -->
					<div class="uk-margin-top">
						<label class="uk-form-label">Template</label>
						<select v-model="formData.template" class="uk-select" required @change="updateComponent">
							<option value="">Selecteer template</option>
							<option v-for="(template, index) in templates" :value="template.id" :key="template.name">
								{{ template.name }}
							</option>
						</select>
					</div>
					
					<!-- template formats -->
					<div class="uk-margin-top" v-if="formData.templateFormats && formData.templateFormats.length > 0">
						<label class="uk-form-label">Format</label>
						<select v-model="formData.templateFormat" class="uk-select">
							<option v-for="format in formData.templateFormats" :key="format.id" :value="format.id" >
								{{ format.id }} 
							</option>
						</select>			
					</div>	

					<!-- template text fields -->
					<div v-for="(element, index) in textElements" :key="index" class="uk-margin-top">
						<textarea
							v-model="formData[element]"
							:name="'element_' + element"
							class="uk-textarea"
							:placeholder="element"
							@input="autoGrow($event)"
						></textarea>
					</div>
							
					<!-- result image -->		
					<div class="uk-margin-top" v-show="resultImage == null && showImage">						
						<div class="uk-text-center">
							<img :src="resultImage" v-show="resultImage" width="75%" />
						</div>
					</div>
					
					<!-- image upload -->
					<div class="uk-margin-top" v-show="uploadForm">
						
						<ul class="uk-subnav uk-subnav-pill" uk-switcher style="margin-bottom: 0">
							<li><a href="#">Afbeelding A</a></li>
							<li><a href="#">Afbeelding B</a></li>
						</ul>
						
						<ul class="uk-switcher">
							<li>
								<image-uploader 
									:max="1" 
									image-field="imageUrl"
									upload-msg="Selecteer of sleep een afbeelding">
								</image-uploader>
							</li>
							<li>
								<image-uploader 
									:max="1" 
									image-field="imageTeaserUrl"
									upload-msg="Upload een teaser afbeelding">
								</image-uploader>									
							</li>
						</ul>

					</div>

					<!-- result image -->
					<div class="uk-margin-top" v-show="resultImage != null">						
						<div class="uk-grid">								
							<div class="uk-width-1-2">
								<a :href="resultImage" target="_blank">
									<img :src="resultImage" v-show="resultImage" style="max-height: 250px" />
								</a>
							</div>
						</div>
					</div>						
				
					<div style="clear:both"></div>
					<button 
						type="submit"
						v-show="!indicator" 
						class="uk-button uk-button-primary uk-align-right uk-margin-top uk-margin-remove-bottom">
						Genereren
					</button>

					<button 
						v-show="!indicator" 
						@click.prevent="resetForm"
						class="uk-button uk-button-secondary uk-align-right uk-margin-top uk-margin-remove-bottom">
						Reset
					</button>		
							
					<div class="uk-text-right uk-margin-top" v-show="indicator">
						<LoadingIndicator />
					</div>
					
					<div class="uk-alert uk-margin-remove uk-margin-top" 
						v-html="response" 
						v-show="response" 
						v-bind:class="{ 'uk-alert-success' : response == true, 'uk-alert-danger' : success == false }"
						@click="hideResponse"
					>
					</div>
				</form>				
			</div>
		</div>	
	</span>
</template>

<script>
import axios from 'axios';
import ImageUploader from './ImageUploader.vue';
import LoadingIndicator from './LoadingIndicator.vue';

export default {
	name: "cards-generator",
	components: { ImageUploader, LoadingIndicator },
	props: {
		fieldMappings: { type: Array, default: () => [] },
		templates: Object,
		defaultTemplate: String,
		targetElement: String,
		buttonText: {
			type: String,
			default: "Cards",
		},
		platformType: String,
		debug: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			apiUrl: '/actions/_cards/card-generator',
			formData: {
				imageUrl: null,
				imageTeaserUrl: null,
				template: this.defaultTemplate || null,
				templateFormat: null,
				templateFormats: [],
			},
			textElements: [],
			fieldMappingsInternal: [],
			indicator: false,
			response: false,
			success: false,
			resultImage: null,
			showImage: true,
			uploadForm: false
		};
	},
	mounted() {
		
		// Set initial template
		this.formData.template = this.templates[0].id;

		// Fetch template formats
		this.fetchTemplateFormats();
		
		// Show upload form
		this.showUploadForm();
		
		// Map fields
		if (this.fieldMappings && this.fieldMappings.length > 0) {
			this.initializeFieldMappings(this.fieldMappings);
		} else {
			this.fetchTemplateTextFields();
		}
	},
	methods: {
		updateComponent() {
			this.fetchTemplateFormats();
			this.fetchTemplateTextFields();
		},
		autoGrow(event) {
			console.log('test')
			const textarea = event.target;
			textarea.style.height = "auto"; 
			textarea.style.height = `${textarea.scrollHeight}px`; 
		},
		fetchFieldMappings() {
			
			var component = this;
			
			axios
				.get(this.apiUrl + '/get-field-mappings')
				.then((response) => {
					if (response.data.success) {
						component.initializeFieldMappings(response.data.fieldMappings);
					}
				})
				.catch((error) => {
					console.error('Error fetching field mappings:', error);
				});
		}, 
		initializeFieldMappings(fieldMappings) {
			fieldMappings.forEach((field) => {
				if (!this.formData.hasOwnProperty(field.field)) {
					console.log(field.field);
					this.formData[field.field] = field.value || '';
				}
			});
			this.fieldMappingsInternal = fieldMappings;
		},
		fetchTemplateTextFields() {
			
			var component = this;	
						
			if(component.platformType != "abyssale") return;
		
			if(!component.formData.template) {
				component.textElements = [];
				return;
			}
			
			component.$logger("app/components/card-generator/fetch-template-elements");
			
			axios.post(`${component.apiUrl}/get-template-data`, {
					template: component.formData.template
				}
			)
			.then(response => {			
				var elements = response.data.response.elements;
										
				if(elements) {		
					component.textElements = elements
						.filter(el => el.type === "text") 
						.map(el => el.name); 		
				}	
			})
			.catch(error => {
				console.error('app/components/card-generator/error fetching template elements:', error);
			});	
		},
		showUploadForm() {
			if (!this.formData.imageUrl) {
				this.uploadForm = true;
			}
		},
		resetForm() {
			Object.keys(this.formData).forEach((key) => {
				this.formData[key] = '';
			});
			this.resultImage = null;
		},
		updateImageUrl(url, imageField) {
			this.$logger("app/components/cards-generator/updateImageUrl: " + url);
			this.$logger("app/components/cards-generator/imageField: " + imageField);			
			this.formData[imageField] = url;
		},	
		submitForm(e) {
					
			var component = this;
			
			// Form data
			var form = e.target;
			var formData = new FormData(form);
						
			// Add dynamic fields from formData to the FormData object
			Object.entries(this.formData).forEach(([key, value]) => {
				// Check if the key already exists in the FormData object
				if (!formData.has(key)) {
					formData.append(key, value);
				}
			});
			
			this.indicator = true;
			
			axios
				.post(this.apiUrl + '/generate', formData, {
					headers: { 'Content-Type': 'multipart/form-data' },
				})
				.then((response) => {
					
					//console.log(response);
					
					this.indicator = false;
					if (response.data.success) {
						this.resultImage = response.data.response.file?.url || null;
					} else {
						this.response = response.data.errors?.join('<br />') || 'Error generating card';
						
						setTimeout(function () {
							component.response = false;
						}, 10000);
					}
				})
				.catch((error) => {
					this.indicator = false;
					console.error(error);
				});
		},
		fetchTemplateFormats() {
			
			var component = this;
					
			if(component.platformType != "abyssale") return;
		
			component.$logger("app/components/cards-generator/fetch-template-formats");
		
			if(!this.formData.template) {
				component.formData.templateFormats = [];
				return;
			}
			
			axios.post(`${component.apiUrl}/get-template-data`, {
					template: component.formData.template
				}
			)
			.then(response => {
				
				component.formData.templateFormats = response.data.response.formats;
				
				if (component.formData.templateFormats && component.formData.templateFormats.length > 0) {
					component.formData.templateFormat = component.formData.templateFormats[0].id; // Auto-select the first format
					component.formData.templateFormat = component.formData.templateFormats[0].id;
				} else {
						
				}
								
			})
			.catch(error => {
				component.$logger('app/components/cards-generator/error fetching template data:', 'error');
				component.$logger(error);
			});	
		},
	},
};
</script>


<style scoped>
#cards-generator-modal {
	z-index: 999999 !important
}
#cards-generator-modal textarea.title {
  resize: vertical;
  min-height: 100px;
}
#cards-generator-modal textarea.caption {
  resize: vertical;
  min-height: 60px;
}
</style>
